<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">机构管理员</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <div v-if="!error">
            <van-cell-group>
                <van-cell>
                    提示：设定授权后，该用户可以查看我的所有学员
                </van-cell>
                <van-cell>
                    <van-field v-model="user_id" label="授权用户ID:" label-width="120px"/>
                </van-cell>
                <van-cell>
                    <van-button type="info" size="small" block @click="addManger">授权</van-button>
                </van-cell>
            </van-cell-group>


            <van-cell-group title="当前已授权用户">
                <van-cell v-for="user in users" :key="user.id">
                    <template #title>
                        {{user.nickname}} (ID:{{user.id}})
                    </template>
                    <template #right-icon>
                        <van-button @click="delManger(user.id)" size="mini" text="移除" type="danger"/>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>

        <div v-else>
            {{error_text}}
        </div>

        <van-dialog v-model="loading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{loading_text}}</van-loading>
            <br>
        </van-dialog>


    </div>
</template>

<script>
    export default {
        data() {
            return {

                user_id: "",

                loading: false,
                loading_text: "加载中",
                error: false,
                error_text: "",

                users: []
            };
        },
        created() {
            this.onLoad()
        },
        methods: {
            onLoad() {
                this.loading = true;
                this.$http.get("/wechat/organ/mangers", {
                    params: {}
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (!res.data.data || res.data.data.length <= 0) {
                        this.finished = true
                        return;
                    }

                    this.users = res.data.data;
                });
            },
            addManger() {
                this.$http.post("/wechat/organ/mangers", {
                    action:"add",
                    user_id:parseInt(this.user_id)
                }).then(res => {
                    this.user_id=""
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    this.onLoad();
                });
            },
            delManger(user_id) {
                console.log(user_id)
                this.$http.post("/wechat/organ/mangers", {
                    action:"del",
                    user_id:user_id
                }).then(res => {
                    console.log(res.data);

                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    this.onLoad();
                });

            },
        }
    }
</script>
